import {InjectionToken, Provider} from '@angular/core';
import {ActionReducerMap} from '@ngrx/store';
import {CustomUnavailableProductsListState} from '../custom-unavailable-products-state';
import {
  CustomUnavailableProductsActionTypes,
  CustomUnavailableProductsListActions
} from '../actions/custom-unavailable-products.action';

export const initialState: any[] = [];

export const initialUnavailableProductsState: any = {};

export function UnavailableProductsReducer(
  state = initialState,
  action: CustomUnavailableProductsListActions,
): any[] {
  switch (action.type) {
    case CustomUnavailableProductsActionTypes.LOAD_UNAVAILABLEPRODUCTS_FAIL: {
      return initialState;
    }
    case CustomUnavailableProductsActionTypes.LOAD_UNAVAILABLEPRODUCTS_SUCCESS: {
      return action.payload ? action.payload : initialState;
    }
    case CustomUnavailableProductsActionTypes.RESET_UNAVAILABLEPRODUCTS: {
      return initialState;
    }
  }
  return state;
}

export function getUnavailableProductsReducers(): ActionReducerMap<CustomUnavailableProductsListState> {
  return {
    unavailableproducts: UnavailableProductsReducer
  };
}

export const reducerUnavailableProductsToken: InjectionToken<ActionReducerMap<CustomUnavailableProductsListState>> = new InjectionToken<ActionReducerMap<CustomUnavailableProductsListState>>(
  'UnavailableProductsReducers',
);

export const reducerUnavailableProductsProvider: Provider = {
  provide: reducerUnavailableProductsToken,
  useFactory: getUnavailableProductsReducers,
};
